/**
 * Nav.tsx — Navegação do site institucional Nectaris
 * Fiel ao Claude Design: sticky, light glass, links simples,
 * CTA âmbar "Falar com o grupo"
 * Fonte: Nectaris - Home.dc.html (linha 25-38)
 */

import { NavLink } from "react-router";
import { useMobileMenu } from "./hooks";
import { NectarisLogoMark } from "./atoms";

export function Nav() {
  const { open, toggle, close } = useMobileMenu();

  return (
    <header>
      <nav className="ns-nav" aria-label="Navegação principal">
        <div className="ns-nav__row">
          {/* Logo */}
          <NavLink
            to="/"
            className="ns-nav__logo"
            aria-label="Nectaris — página inicial"
            onClick={close}
          >
            <NectarisLogoMark size={44} />
            <span className="ns-nav__logo-text">
              <span className="ns-nav__wordmark">NECTARIS</span>
              <span className="ns-nav__subtag" aria-hidden="true">performance empresarial</span>
            </span>
          </NavLink>

          {/* Links desktop */}
          <ul className="ns-nav__links" role="list">
            <li>
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `ns-nav__link${isActive ? " ns-nav__link--active" : ""}`
                }
                onClick={close}
              >
                Início
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/o-grupo"
                className={({ isActive }) =>
                  `ns-nav__link${isActive ? " ns-nav__link--active" : ""}`
                }
                onClick={close}
              >
                O grupo
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/iniciativas"
                className={({ isActive }) =>
                  `ns-nav__link${isActive ? " ns-nav__link--active" : ""}`
                }
                onClick={close}
              >
                Iniciativas
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contato"
                className="ns-nav__cta"
                onClick={close}
                aria-label="Falar com o grupo Nectaris"
              >
                Falar com o grupo
              </NavLink>
            </li>
          </ul>

          {/* Hamburguer mobile */}
          <button
            type="button"
            className="ns-nav__hamburger"
            onClick={toggle}
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            aria-expanded={open}
            aria-controls="ns-mobile-menu"
          >
            {open ? "✕" : "☰"}
          </button>
        </div>

        {/* Menu mobile */}
        <div
          id="ns-mobile-menu"
          className={`ns-nav__mobile${open ? " ns-nav__mobile--open" : ""}`}
          aria-hidden={!open}
        >
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `ns-nav__mobile-link${isActive ? " ns-nav__mobile-link--active" : ""}`
            }
            onClick={close}
          >
            Início
          </NavLink>
          <NavLink
            to="/o-grupo"
            className={({ isActive }) =>
              `ns-nav__mobile-link${isActive ? " ns-nav__mobile-link--active" : ""}`
            }
            onClick={close}
          >
            O grupo
          </NavLink>
          <NavLink
            to="/iniciativas"
            className={({ isActive }) =>
              `ns-nav__mobile-link${isActive ? " ns-nav__mobile-link--active" : ""}`
            }
            onClick={close}
          >
            Iniciativas
          </NavLink>
          <NavLink
            to="/contato"
            className="ns-nav__mobile-cta"
            onClick={close}
          >
            Falar com o grupo
          </NavLink>
        </div>
      </nav>
    </header>
  );
}
